
/* search module */
(function(){
	if(typeof DMheader === "undefined") { DMheader = {}; }

	var search_input,
		search_params,
		search_form,
		search_input_placeholder;

	function init(params){
		if(typeof params !== "undefined" && Object.keys(params).length > 0){
			search_params = params;
		} else {
			search_params = {};
		}

		search_container = document.getElementsByClassName("dm20-header-overlay-search-container")[0];
		search_input = document.getElementsByClassName("dm20-header-overlay-search-input")[0];
		search_form = document.querySelectorAll(".dm20-search-form");
		bindHandlers();
	}

	function bindHandlers(){
		search_input.addEventListener('input', handleTyping, false);

		if(search_params.submitCallback){
			search_form.forEach(sform => {
				sform.addEventListener('submit', function(ev){
					window[search_params.submitCallback](ev);
				}, false);
			})
		}

		if(search_input_placeholder && search_params.visible){
			search_input.placeholder = search_input_placeholder;
		}
	}

	function handleTyping(ev){
		if(search_input.value.length != 0){
			search_container.classList.add("dm20-header-overlay-search-active");
		} else {
			search_container.classList.remove("dm20-header-overlay-search-active");
		}
	}

	DMheader.search = init;
}());

/* social module */
(function(){
	if(typeof DMheader === "undefined") { DMheader = {}; }

	var overlay_social;

	function init(params){
		var overlay_social = document.getElementById("dm20-header-overlay-social");

		if(overlay_social && typeof params !== "undefined" && params.length > 0){
			var social_links = getSocialLinks(params);
			if(social_links != ""){
				overlay_social.innerHTML = social_links;
				overlay_social.classList.remove("dm20-header-hidden");
			}
		}
	}

	function getSocialLinks(social_list) {
		var list = social_list,
			links = "";

		for (var i = 0; i < list.length; i++) {
			var icon = '';
			switch(list[i].className){
				case "dm20-header-facebook":
					icon = '<span class="dm20-icon"><svg viewBox="0 0 28 28"><use xlink:href="/content/themes/donnamoderna/2020assets/images/icons.svg#dm20-social-fb" /></svg></span>';
				break;

				case "dm20-header-tiktok":
					icon = '<span class="dm20-icon"><svg viewBox="0 0 80 60"><use xlink:href="/content/themes/donnamoderna/2020assets/images/icons.svg#dm20-social-tt" /></svg></span>';
				break;

				case "dm20-header-pinterest":
					icon = '<span class="dm20-icon"><svg viewBox="0 0 16 20"><use xlink:href="/content/themes/donnamoderna/2020assets/images/icons.svg#dm20-social-pt" /></svg></span>';
				break;

				case "dm20-header-twitter":
					icon = '<span class="dm20-icon"><svg viewBox="0 0 29 31"><use xlink:href="/content/themes/donnamoderna/2020assets/images/icons.svg#dm20-social-tw" /></svg></span>';
				break;

				case "dm20-header-instagram":
					icon = '<span class="dm20-icon"><svg viewBox="0 0 60 60"><use xlink:href="/content/themes/donnamoderna/2020assets/images/icons.svg#dm20-social-in" /></svg></span>';
				break;

				default:
				break;
			}

			links += '<a href="'+list[i].url+'" class="dm20-header-social-channel '+list[i].className+'" title="'+list[i].name+'" target="_blank" rel="nofollow">' + icon + '</a>';
		}

		return links;
	}

	DMheader.social = init;
}());

/* populateModule module */
(function(){
	if(typeof DMheader === "undefined") { DMheader = {}; }

	var prefix = "dm20-header-",
		el,
		el_tofill;

	function init(el_name, el_tofill_name){
		el = document.getElementById(prefix + el_name);
		el_tofill = document.getElementById(prefix + el_tofill_name);
		populate();
	}

	function populate(){
		if(el && el_tofill){
			if(el.classList.contains('dm20-header-overlay-nav')){
				el_tofill.innerHTML = el.innerHTML + '<div class="dm20-header-nav-overflow" id="dm20-header-nav-overflow"><div class="dm20-header-nav-overflow-menu" id="dm20-header-nav-overflow-menu"><span></span></div></div>';
				cleanNavigation(el_tofill);
			} else if(el.classList.contains('dm20-header-special')){
				el_tofill.innerHTML = '<a data-boxtype="menu_header" href="https://www.abbonamenti.it/vincolata/r31606?utm_source=sito_donnamoderna&utm_campaign=menu&utm_medium=referral">Abbonati</a>';
                        } else if(el.classList.contains('dm20-header-newsletter')){
                                el_tofill.innerHTML = '<a data-boxtype="menu_header" href="/newsletter">Newsletter</a>';
                        } else {
				el_tofill.innerHTML = el.innerHTML;
			}
		}
	}

	function cleanNavigation(element){
		var firstLevelList = element.querySelector('ul').children;

		for(var i=0; i<firstLevelList.length; i++){
			var item = firstLevelList[i];

			if(item.classList.contains('dm20-header-has-children')){
				item.classList.remove('dm20-header-has-children');
				item.removeChild(item.querySelector('ul'));
			}
			if(item.classList.contains('opened')){
				item.classList.remove('opened');
			}
		}
	}

	DMheader.populateModule = init;
}());

/* hideComponent module */
(function(){
	if(typeof DMheader === "undefined") { DMheader = {}; }

	var prefix = "dm20-header-",
		el;

	function init(el_name){
		el = document.getElementById(prefix + el_name);
		hide();
	}

	function hide(){
		if(el){
			el.classList.add("dm20-header-hidden");
		}
	}

	DMheader.hideComponent = init;
}());

/* menuManager module */
(function(){
	if(typeof DMheader === "undefined") { DMheader = {}; }

	var children;

	function init(){
		children = document.querySelectorAll(".dm20-header-has-children");

		for(var i = 0; i < children.length; i++) {
			buildAccordion(children[i]);
		}

		checkSelected("nav");
		checkSelected("overlay_nav");
	}

	function checkSelected(navType){
		var nav = document.getElementById("dm20-header-" + navType);
		if(nav){
			var selectedElements = nav.querySelectorAll(".selected");

			if(selectedElements.length > 0){
				var lastOfSelected = selectedElements[selectedElements.length-1];

				for (var i = (navType == "nav") ? 1 : 0; i < selectedElements.length; i++) {
					if(selectedElements[i] != lastOfSelected && selectedElements[i].classList.contains("selected")){
						selectedElements[i].classList.remove("selected");
					}
				}
			}
		}
	}

	function buildAccordion(item){
	    var target = item;
	    if(target.classList.contains("selected")){
	    	target.classList.add("opened");
	    }

	    var links = target.querySelectorAll('.dm20-header-has-children a');
	    for (var i = 0; i < links.length; i++) {
		    links[i].addEventListener('click', function (ev) {
		        ev.stopPropagation();
		    });
	    }

	    target.addEventListener('click', handleAccordion, false);
	}

	function handleAccordion(ev){
		ev.preventDefault();
		ev.stopPropagation();
		var currentTarget = this;

		if(currentTarget.classList.contains("opened")){
			currentTarget.classList.remove("opened");
		} else {
			currentTarget.classList.add("opened");
		}
	}

	DMheader.menuManager = init;
}());

/* stickyHeader module */
(function(){
	if(typeof DMheader === "undefined") { DMheader = {}; }

	var body,
		header,
		nav,
		secondLevelNavs,
		strip_adv,
		pamela,
		stuck;

	function init(){
		body = document.getElementsByTagName("body")[0];
		header = document.getElementById("dm20-header");
		nav = document.getElementById("dm20-header-nav");
		strip_adv = document.getElementById("gpt_strip_adv");
		pamela = document.getElementById("av-pushdown-wrapper");
		stuck = false;

		window.addEventListener("scroll", handleSticky);
	}

	function getOffsetTop(){
		var offset = 0;

		return offset;
	}

	function handleSticky(){
		var stick_point = getOffsetTop() + strip_adv.offsetHeight + pamela.offsetHeight;
		var distance = stick_point - window.pageYOffset;
		var offset = window.pageYOffset;

		if(!body.classList.contains("pushing")){
			if (distance <= 0 && !stuck) {
				body.classList.add("dm20-sticky");
				header.classList.add("dm20-header-sticky");
				stuck = true;
			} else if (stuck && (offset <= stick_point)){
				body.classList.remove("dm20-sticky");
				header.classList.remove("dm20-header-sticky");
				stuck = false;
			}
		}
	}

	DMheader.stickyHeader = init;
}());

/* handlers module */
(function(){
	if(typeof DMheader === "undefined") { DMheader = {}; }

	var body,
		html,
		menuTriggers,
		close_button,
		close_panel,
		open_menu,
		overlay_container,
		nav_overflow_menu,
		pageYOffset;

	function init(){
		console.log("init");
		html = document.getElementsByTagName("html")[0];
		body = document.getElementsByTagName("body")[0];
		menuTriggers = document.querySelectorAll(".menu-trigger");
		open_menu = document.getElementsByClassName("dm20-header-open-menu");
		close_button = document.getElementById("dm20-header-overlay-close");
		close_panel = document.getElementById("dm20-header-overlay-close-panel");
		bindHandlers();
	}

	function bindHandlers(){
		menuTriggers.forEach(trigger => {
			trigger.addEventListener("click", toggleOverlay, false);
		})
		for (var i = 0; i < open_menu.length; i++) {
			open_menu[i].addEventListener("click", toggleOverlay, false);
		}
		close_button.addEventListener("click", toggleOverlay, false);
		close_panel.addEventListener("click", hideOverlay, false);
	}

	function toggleOverlay(ev){
		ev.preventDefault();
		ev.stopImmediatePropagation();
		if(body.classList.contains("dm20-header-overlay-opened")){
			body.classList.remove("dm20-header-overlay-opened");
			window.scrollTo(0,pageYOffset);
			document.removeEventListener("touchmove", preventScroll, false);
		} else {
			pageYOffset = window.pageYOffset;
			body.classList.add("dm20-header-overlay-opened");
			document.addEventListener("touchmove", preventScroll, false);
		}
	}

	function preventScroll(ev){
	    if(!findParentByClassName(ev.target, "dm20-header-overlay-opened")){
	    	ev.preventDefault();
	    }
	}

	function findParentByClassName(el,className) {
    	while (el.parentNode && el.parentElement !== html) {
        	el = el.parentNode;
        	if (el.classList.contains(className)){
            	return el;
        	}
    	}
    	return null;
	}

	function hideOverlay(ev){
		if(body.classList.contains("dm20-header-overlay-opened")){
			body.classList.remove("dm20-header-overlay-opened");
			document.removeEventListener("touchmove", preventScroll, false);
		}
	}

	DMheader.handlers = init;
}());

/*
Inizializzazione DMheader
- popolamento logo
- popolamento del menù di navigazione presente nell'overlay
- gestione del funzionamento del menù
- gestione sticky header allo scroll
- bind eventi generici
*/
(function(o){
	if(typeof o === "undefined") { return; }
	var DMheaderOptions = JSON.parse(JSON.stringify(o));
    DMheader.menuManager();
	DMheader.handlers();

	for(var i in DMheaderOptions){
		if(i !== "topstrip"){
			if(DMheaderOptions[i]){
				DMheader.populateModule(i, "overlay-" + i);
				if(DMheader[i]){
					if(typeof DMheaderOptions[i] !== "boolean"){
						DMheader[i](DMheaderOptions[i]);
					} else {
						DMheader[i]();
					}
				}
			} else {
				DMheader.hideComponent(i);
			}
		}
	}

	// DMheader.calcNavigationWidth();
})(DMheaderOptions);

function doSubmit(ev) {
    ev.preventDefault();
	ev.stopPropagation();

	let search_input_value = ev.currentTarget.querySelector(':scope > .dm20-search-input').value;

	if (search_input_value != "") {
        window.location.href = dmHomePageUrl + '/cerca/' + encodeURIComponent(search_input_value);
	}
}

async function postData(url = '', data = {}) {
	// Default options are marked with *
	const response = await fetch(url, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'cors', // no-cors, *cors, same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		credentials: 'same-origin', // include, *same-origin, omit
		headers: {
			'Content-Type': 'application/json'
		},
		redirect: 'follow', // manual, *follow, error
		referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
		body: JSON.stringify(data) // body data type must match "Content-Type" header
	});
	return response.json(); // parses JSON response into native JavaScript objects
}

// tracking links abbonamenti in pagina
let TrackAbbonamenti = () => {
	let abbbtns = document.querySelectorAll('a[href^="https://www.abbonamenti.it/"]');
	Array.from(abbbtns).forEach((el) => {
		let boxtype = el.getAttribute('data-boxtype') ? el.getAttribute('data-boxtype') : 'box_other'; // fallback
		el.addEventListener('click', (e) => {
		console.debug("clicked on " + boxtype.toString());
			// ga('send', {
			// hitType: 'event',
			// eventCategory: 'Abbonati',
			// eventAction: 'click',
			// eventLabel: boxtype.toString(),
			// nonInteraction: false
			// });

			gtag('event', 'Click', {
				'event_category': 'Abbonati',
				'event_label': boxtype.toString(),
				'non_interaction': true
				});
		});
	});
	console.debug('[TrackAbbonamenti] '+abbbtns.length+' buttons found.');
}
TrackAbbonamenti();

let TrackNewsletter = () => {
	let newsletter = document.querySelector('input.dm20-footer-newsletter-form-submit');
	if (newsletter) {
		newsletter.addEventListener('click', (e) => {
			gtag('event', 'Click', {
				'event_category': 'Iscrizione Newsletter',
				'event_label': window.location.href,
				'non_interaction': true
				});
			console.debug('[TrackNewsletter] '+window.location.href);
		});
	}
}
TrackNewsletter();


/* FALLBACK FONT PER FIREFOX WINDOWS */
/*if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && window.navigator.platform.toLowerCase().indexOf('win') > -1){
    let link = document.createElement('link');
    link.href = "https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@100;200;300;400;500;600;700&display=swap";
    link.rel = "stylesheet"
    document.head.appendChild(link);
}
*/
/*
(function(){
    function postConsentRejected(cb) {
        if(typeof window.ameConsentGiven !== 'undefined' && window.ameConsentGiven == false) {
            console.log('[Ame consent rejected] cb by variable:',cb.name);
            cb();
        } else {
            window.addEventListener('consentRejected', function() {
                console.log('[Ame consent rejected] cb by listener:',cb.name);
                cb();
            });
        }
    }

    function startMediamondNoConsent() {
		window._gmp = window._gmp || {};
		window._gmp.consentState = null;
		if (adplay_on) {
				(function() {
					var s = document.createElement('script');
					s.type = 'text/javascript';
					s.async = true;
					s.src = adv_script_src;
					var sc = document.getElementsByTagName('script')[0];
					sc.parentNode.insertBefore(s, sc);
				})();
			}
		}
    postConsentRejected(startMediamondNoConsent);
})();
*/